import { useContext, useState,useMemo } from "react";
import MultiComparisonComponent from "../../Dashboard/Component/MultiComparisonComponent";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import classes from "./CompetitiveSummary.module.css";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import { AuthContext } from "../../../context/auth-context";
import Checkbox from "@mui/material/Checkbox";
import { tab } from "../BrandScore/BrandScore";
import { filterKey } from "../BrandAudit";
import MUIIconButton from "./../../../Component/UI/MUIIconButton/MUIIconButton";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import Modal from "../../../Component/Modal/Modal";
import Share from "../Share/Share";
import { toast } from "react-toastify";

export default function CompetitiveSummary() {
  const discoveryCtx = useContext(DiscoveryContext);
  const [showShareModal, setShowShareModal] = useState(false);
  const { user } = useContext(AuthContext);
  const customerId = user?.customer_id || 0;
  let primary_llm = discoveryCtx.primary_llm;
  let llms = discoveryCtx.llm;
  const selectedMarket = discoveryCtx?.state?.selectedMarket ?? "";
  const selectedCategory = discoveryCtx.state.selectedCategory;
  const selectedPersona = discoveryCtx.state.selectedPersona;
  let competitors = discoveryCtx?.competitors?.[selectedCategory]?.map(
    (c) => c.name
  ) ?? [];
  competitors.unshift(discoveryCtx.entity);
  const id = "Competitor_Summary";
  let uniqueKey = `${tab.competitiveOverview}_${id}_${selectedCategory}_${selectedMarket}_${selectedPersona}`;
  const { checked } = useIsSelectedSection({
    id,
    tab: tab.competitiveOverview,
    uniqueKey,
  });

const personaOptions = useMemo(() => {
  return (discoveryCtx?.persona || [])
    .map(p => {
      // New record format
      if (typeof p === "object" && p?.title) {
        return {
          name: p.title,
          value: p.title,
        };
      }

      // Old record format
      if (typeof p === "string") {
        return {
          name: p,
          value: p,
        };
      }

      return null;
    })
    .filter(Boolean);
}, [discoveryCtx?.persona]);


  const getBrandScores = (type) => {
    const brandScoresMap = {};

    llms?.forEach((llmName) => {
      const scores = discoveryCtx?.brand_scores?.[llmName] || {};
      // const market = discoveryCtx.markets[0];
      const categories = Object.keys(scores);

      const categoryScores = scores[selectedCategory] || {};

      // ✅ persona-level mapping added here
      const personaScores =
        categoryScores[selectedMarket]?.[selectedPersona] || [];

      if (!Array.isArray(personaScores) || personaScores.length === 0) {
        console.warn(
          `No personaScores found for category "${selectedCategory}" and persona "${selectedPersona}"`
        );
        return;
      }

      if (!brandScoresMap[llmName]) {
        brandScoresMap[llmName] = {};
      }

      personaScores.forEach((score, idx) => {
        if (!score || typeof score !== "object") {
          console.warn(`Invalid score object at index ${idx} for llm "${llmName}"`);
          return;
        }

        const reordered = [
          score?.[type] ?? null,
          ...personaScores
            .filter((_, i) => i !== idx)
            .map((item) =>
              item && type in item ? item[type] : null
            ),
        ];

        brandScoresMap[llmName][
          score.name.toLowerCase().replace(/\s+/g, "") ||
          `unknown_${idx}`
        ] = reordered;
      });
    });

    return { brandScoresMap };
  };


  const getBrandDomains = () => {
    const competitors = discoveryCtx.competitors;
    const categories = Object.keys(competitors);
    const brandDomains = {};
    // const mainProduct = getBrandScores("favorability").mainBrandProduct;
    categories.map((category) => {
      competitors[category].map((record) => {
        // if (mainProduct.toLowerCase() == record.name.toLowerCase()) {
        //     brandDomains[mainProduct] = record.domain;
        // } else {
        brandDomains[record.name] = record.domain;
        // }
      });
    });
    return brandDomains;
  };

  const getIndexScoreMetaData = () => {
    let indexScoreMetaData = [];
    llms.forEach((llm) => {
      const brandIndexScores = discoveryCtx?.brand_scores?.[llm] || {};
      const categories = Object.keys(brandIndexScores);
      categories.map((category) => {
        indexScoreMetaData[category] = {};
        const marketScores = brandIndexScores[category] || {};
        const personaScore = marketScores[selectedMarket] || {};
        const primaryMarketScore = personaScore[selectedPersona] || [];
        indexScoreMetaData = indexScoreMetaData.concat(
          primaryMarketScore.map((score) => {
            return {
              ...score,
              category: category,
              market: selectedMarket,
              llm: llm,
              persona: selectedPersona,
              geography: "",
            };
          })
        );
      });
    });
    return indexScoreMetaData;
  };

  return (
    <>
      <div className="Heading-checkbox">
        <div className={classes.dropdownWrapper}>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
            <h5>Competitor Summary</h5>
            {discoveryCtx.state.showReportCheckbox && (
              <Checkbox
                checked={checked}
                onChange={() => {
                  discoveryCtx?.clickComponentCheckbox({
                    uniqueKey,
                    filter: {
                      id: id,
                      title: "Competitor Summary",
                      tab: tab.competitiveOverview,
                      uniqueKey,
                      llm: null,
                      competitor: null,
                    },
                    checked,
                    id,
                  });
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            )}
          </div>
          <div className={classes.categoryWrapper}>
            <MUISelect
              fullWidth={false}
              optionValue={discoveryCtx.state.selectedPersona}
              label={"Persona"}
              id={filterKey.persona}
              options={personaOptions}
              onChange={(e) => {
                discoveryCtx.updateSelectedPersona(e.target.value);
              }}
            />
            <MUISelect
              fullWidth={false}
              optionValue={discoveryCtx.state.selectedCategory}
              label={"Category"}
              id={filterKey.category}
              options={(discoveryCtx.category || []).map((category) => {
                return {
                  name: category,
                  value: category,
                };
              })}
              onChange={(e) => {
                discoveryCtx.updateSelectedCategory(e.target.value);
              }}
            />
            <MUISelect
              fullWidth={false}
              optionValue={discoveryCtx.state.selectedMarket}
              label={"Market"}
              id={filterKey.market}
              options={(discoveryCtx?.markets || []).map((market) => {
                return {
                  name: market,
                  value: market,
                };
              })}
              onChange={(e) => {
                discoveryCtx.updateSelectedMarket(e.target.value);
              }}
            />
            <div className={classes.shareIcon}>
              <MUIIconButton
                title="Click to Share"
                onClick={() => setShowShareModal(true)}
              >
                <ShareOutlinedIcon color="primary" />
              </MUIIconButton>
            </div>
          </div>
        </div>
        <hr />


      </div>
      <hr />
      <MultiComparisonComponent
        fetchRealTimeActionsSources={() => { }}
        sourceURLIds={[]}
        reachSourceData={{}}
        sentimentSourceData={{}}
        categoryDimensionRatingSource={{}}
        secCategoryIndexScoreMetaData={{}}
        coreAttSourceData={{}}
        positiveAttSource={{}}
        negativeAttSource={{}}
        customerId={customerId}
        selectedInput={{
          llm: primary_llm,
          market: selectedMarket,
          persona: selectedPersona,
          brand: discoveryCtx.entity,
          product: discoveryCtx.type == "product" ? true : false,
          geography: "",
          category: selectedCategory,
        }}
        productTaxonomyData={{}}
        secCategoryBrandFav={{}}
        secCategoryReach={{}}
        secCategoryBrandIndex={{}}
        indexScoreMetaData={getIndexScoreMetaData()}
        compCoreAttributes={{}}
        compCategoryDimensions={{}}
        pastCompCategoryDimensions={{}}
        pastCompCoreAttributes={{}}
        pastsecCategoryBrandIndex={{}}
        pastIndexScoreObj={{}}
        brandIndex={getBrandScores("total").brandScoresMap}
        brandReach={getBrandScores("rank").brandScoresMap}
        brandFav={getBrandScores("favorability").brandScoresMap}
        positiveAttributes={{}}
        negativeAttributes={{}}
        llmDomains={{}}
        geoLogo={{}}
        activeTab={"category"}
        brandDomains={getBrandDomains()}
        brandProduct={discoveryCtx.entity}
        type={discoveryCtx.type == "brand" ? "Brand" : "Product"}
        brandProductCategory={discoveryCtx.category}
        isBrandAuditPage={true}
        isBrandAuditMarketPage={true}
        competitiveOverview={competitors}
        isOverview={true}
        id={id}
        contextData={discoveryCtx}
      />
      {showShareModal &&
        <Modal
          height="60%"
          title="Share Link"
          open={showShareModal}
          handleClose={() => setShowShareModal(false)}
        >
          <Share setShowShareModal={setShowShareModal} />
        </Modal>
      }
    </>
  );
}
